export function openNewTab(link: string) {
  const win = window.open(link, "_blank")
  // @ts-expect-error: Flow to TS migration.
  win.focus()
}

export function openInSameTab(link: string) {
  window.open(link, "_self")
}
